export function checkIfTimeExists(action, type) {
  if (action && action.payload && action.payload[type]) return true
  return false
}
export function actionHasKey(action, type) {
  if (action && action.hasOwnProperty('payload') && action.payload.hasOwnProperty(type)) return true
  return false
}
